/*
 * fn: parseArchidektDeckText
 *
 * Encodes a list of recs into archidekt's text import format, tagging commanders with the Commander category
 *
 */
import { type RecType } from '@/defs/rec'

const parseLine = (count: number | undefined, name: string, isCommander: boolean) =>
  `${count || 1} ${name}${isCommander ? ' [Commander]' : ''}`

export const parseArchidektDeckText = (recs: RecType[]) =>
  recs.flatMap(({ count, name, partnerRef, role }) => [
    parseLine(count, name, role === 'commander'),
    ...(partnerRef ? [parseLine(count, partnerRef.name, role === 'commander')] : []),
  ])
